import { getCookie, setCookie } from './util';
/**
 * Stores values in cookies
 * @param options
 */
export const cookieStorageAdapter = (options) => ({
    get: getCookie,
    set: (name, value) => {
        setCookie(name, value, (options.lifetime || 31536000) * 1000, options.path || '/');
    },
    remove: name => {
        setCookie(name, '', -999999, options.path || '/');
    },
});
/**
 * Stores values in the localstorage
 */
export const localStorageAdapter = () => ({
    get: (name) => window.localStorage.getItem(name),
    set: (name, value) => window.localStorage.setItem(name, value),
    remove: (name) => window.localStorage.removeItem(name),
});
